import update from "immutability-helper";

import { REMIXES_LOADED, REMIXES_LOADING } from "../actions/types";

export interface StoryGallery {
  _id: string;
  type: string;
  story: string;
  title: string;
  description: string;
  thumbnailURL: string;
  archiveURL: string;
  getThumbnailURL: string;
  duration: number;
  author: string;
  custom_archive_media_type: string;
  projectName: string;
}

export interface Remix {
  _id: string;
  author: string;
  backgroundURL: string;
  created_at: string;
  elements: StoryGallery[];
}

export interface Remixes {
  remixes: Remix[];
  isLoadingRemixes: boolean;
}

const initialState: Remixes = {
  remixes: [],
  isLoadingRemixes: true,
};

const remixesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REMIXES_LOADING: {
      return update(state, { isLoadingRemixes: { $set: true } });
    }
    case REMIXES_LOADED: {
      return update(state, { remixes: { $set: payload }, isLoadingRemixes: { $set: false } });
    }

    default:
      return state;
  }
};

export default remixesReducer;
